(function () {
    'use strict';

    angular
        .module('app.trendyolIntegration')
        .controller('TrendyolEditMatchCategoryFilterValueController', TrendyolEditMatchCategoryFilterValueController);

    TrendyolEditMatchCategoryFilterValueController.$inject = ['$scope', '$stateParams', '$location', 'TrendyolIntegrationService', 'NgTableParams'];

    function TrendyolEditMatchCategoryFilterValueController($scope, $stateParams, $location, TrendyolIntegrationService, NgTableParams) {
        /* jshint validthis:true */
        var vm = this;

        vm.settings = globalSettings;
        activate();

        function activate() {
            vm.firstLoad = true;
            vm.tableParams = new NgTableParams(
                angular.extend({ page: 1, count: 10 }, $location.search()),
                {
                    getData: function () {
                        return TrendyolIntegrationService.getMatchCategoryFilter($stateParams.Id)
                            .then(function (data) {
                                return TrendyolIntegrationService.getCategoryFilterValue(data.MatchCategory.IntegrationCategoryId, data.IntegrationCategoryAttrName)
                                    .then(function (result) {

                                        return result;
                                    });
                            });
                    }
                });

            TrendyolIntegrationService.getMatchCategoryFilter($stateParams.Id)
                .then(function (data) {
                    TrendyolIntegrationService.getOptionValue(data.OptionId).then(function (result) {
                        vm.entity = result;

                        vm.entity.refresh = true;
                        vm.loading = false;
                    });
                });


            vm.MatchCategoryFilterId = $stateParams.Id;
        }

        vm.selectFilterValue = function (filter, option) {
            vm.loading = true;
            vm.catAttrValue = {};
            vm.catAttrValue.OptionValueId = option;
            vm.catAttrValue.MatchCategoryFilterId = $stateParams.Id;
            vm.catAttrValue.IntegrationCategoryAttrValueId = filter.id;
            vm.catAttrValue.IntegrationCategoryAttrValueName = filter.name;
            TrendyolIntegrationService.editMatchCategoryFilterValue(vm.catAttrValue).then(function (data) {
                vm.loading = false;
                $location.path('/trendyolIntegration/trendyoleditmatchcategoryfiltervalue/' + data.MatchCategoryFilterId);
            });
        };

    }
})();